export default "__VITE_ASSET__einPstLY__"